<template>
  <div class="lg:flex">
    <div class="vx-col w-full lg:w-3/5">
      <div ref="baseContainer" class="baseContainer">
        <div class="konvaContainer">
          <v-stage
            ref="stage"
            :config="stageSize"
            @mousedown="handleStageMouseDown"
            @touchstart="handleStageMouseDown"
          >
            <v-layer><v-image :config="baseImage"></v-image></v-layer>
            <v-layer v-if="croquiElements.length" ref="layer">
              <v-image
                v-for="(item, index) in imageElements"
                :key="'image' + index"
                @dragstart="handleDragStart"
                @dragend="handleDragEnd"
                @transformend="handleTransformEnd"
                :config="item"
              ></v-image>
              <v-text
                v-for="(item, index) in textElements"
                :key="'text' + index"
                :config="item"
                @dblclick="handleTextDoubleClick"
              ></v-text>
              <v-transformer ref="transformer" />
            </v-layer>
          </v-stage>
        </div>
      </div>
    </div>

    <div class="vx-col w-full lg:w-2/5 flex flex-col justify-between px-5 py-2">
      <div class="flex flex-wrap">
        <h5 class="title text-2xl mb-6">
          Simule o evento ao lado utilizando os objetos abaixo:
        </h5>
        <div
          class="item-croqui m-1 p-2 rounded-lg"
          v-for="(item, index) in tiposElementos"
          :key="index"
          @click="addElementCroqui(item)"
        >
          <img class="w-12 h-12" :src="item.src" alt="icone" />
        </div>
      </div>
      <div class="flex justify-end gap-5">
        <vs-button radius color="danger" class="h-16 w-16" @click="resetCroqui"
          ><feather-icon icon="Trash2Icon" svgClasses="h-6 w-6"></feather-icon
        ></vs-button>

        <vs-button
          radius
          color="#114880"
          class="h-16 w-16"
          @click="salvarCroqui"
          ><feather-icon icon="SaveIcon" svgClasses="h-6 w-6"></feather-icon
        ></vs-button>
      </div>
    </div>
    <vs-popup
      @close="modalTextCroqui = false"
      :active.sync="modalTextCroqui"
      title="selectedShapeName"
      ><div class="flex gap-2 justify-between">
        <vs-input
          class="w-full"
          size="large"
          v-model="croqui.text"
          label="Texto"
        />
        <div class="flex flex-col justify-between mb-1">
          <small>Cor</small>
          <input
            type="color"
            class="w-12 h-12 color-picker"
            v-model="croqui.fill"
          />
        </div>
      </div>
      <div class="w-full flex justify-end mt-6">
        <vs-button @click.stop.prevent="aplicaEstiloTextoCroqui"
          >Aplicar</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>
<script>
import canvasToBlob from 'blueimp-canvas-to-blob';
import CROQUI_ICONS, {
  CROQUI_BASE_IMAGE_URL,
} from '../../shared/croqui-icons-imports.js';
import { FOTO_REFERENTE_IMAGE_CROQUI } from '../../shared/const';
import functions from '../../../../../utils/functions';
import service from '../../../../../services';
import notify from '../../../../../utils/notify';

export default {
  name: 'croqui-evento',
  props: ['formData', 'newBaseImageCroqui'],
  data() {
    return {
      tiposElementos: [],
      stageSize: {
        id: 'canvas-container',
        width: 0,
        height: 0,
      },
      isDragging: false,
      croquiElements: [],
      selectedShapeName: '',
      imagemCroquiSava: null,
      baseImageURL: CROQUI_BASE_IMAGE_URL,
      baseImage: {},
      icons: CROQUI_ICONS,
      idReferente: FOTO_REFERENTE_IMAGE_CROQUI,
      idEvento: null,
      idUsuario: null,
      contador: {
        cars: 0,
        motorcycles: 0,
        trucks: 0,
        pedestrians: 0,
      },
      modalTextCroqui: false,
      croqui: {
        text: '',
        fill: '',
        id: null,
      },
    };
  },
  watch: {
    formData(value) {
      const { idEvento } = this.formData;
      const { idUsuario } = functions.getDecoded(localStorage);

      this.idEvento = idEvento;
      this.idUsuario = idUsuario;

      if (value.imageCroqui.length) {
        this.updateBaseImage(value.imageCroqui[0]);
        return;
      }

      this.loadBaseImage();
    },
    newBaseImageCroqui(value) {
      if (value) {
        this.updateBaseImage(value);
      }
    },
  },
  created() {
    // Adicionar um listener para o evento 'resize' da janela
    window.addEventListener('resize', this.konvaArea);
  },
  destroyed() {
    // Remover o listener quando o componente for destruído
    window.removeEventListener('resize', this.konvaArea);
  },
  mounted() {
    this.konvaArea();
    this.preencheItemsCroqui();
  },
  computed: {
    imageElements() {
      return this.croquiElements.filter(({ text }) => !text);
    },
    textElements() {
      return this.croquiElements.filter(({ text }) => text);
    },
  },
  methods: {
    handleTransformEnd(e) {
      // shape is transformed, let us save new attrs back to the node
      // find element in our state
      const rect = this.croquiElements.find(
        (r) => r.name === this.selectedShapeName,
      );
      // update the state
      rect.x = e.target.x();
      rect.y = e.target.y();
      rect.rotation = e.target.rotation();
      rect.scaleX = e.target.scaleX();
      rect.scaleY = e.target.scaleY();
    },
    handleStageMouseDown(e) {
      // clicked on stage - clear selection
      if (e.target === e.target.getStage()) {
        this.selectedShapeName = '';
        this.updateTransformer();
        return;
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer =
        e.target.getParent().className === 'Transformer';
      if (clickedOnTransformer) {
        return;
      }

      // find clicked rect by its name
      const name = e.target.name();
      const rect = this.croquiElements.find((r) => r.name === name);
      if (rect) {
        this.selectedShapeName = name;
      } else {
        this.selectedShapeName = '';
      }
      this.updateTransformer();
    },
    updateTransformer() {
      // here we need to manually attach or detach Transformer node
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();
      const { selectedShapeName } = this;

      const selectedNode = stage.findOne('.' + selectedShapeName);
      // do nothing if selected node is already attached
      if (selectedNode === transformerNode.node()) {
        return;
      }

      if (selectedNode) {
        // attach to another node
        transformerNode.nodes([selectedNode]);
      } else {
        // remove transformer
        transformerNode.nodes([]);
      }
      transformerNode.getLayer().batchDraw();
    },
    handleDragStart() {
      this.isDragging = true;
    },
    handleDragEnd() {
      this.isDragging = false;
    },
    konvaArea() {
      const baseImage = this.$refs.baseContainer;
      this.stageSize.width = baseImage.clientWidth;
      this.stageSize.height = baseImage.clientHeight;
      this.baseImage.width = baseImage.clientWidth;
      this.baseImage.height = baseImage.clientHeight;
    },
    loadBaseImage() {
      const temCroquiDefinido =
        this.formData.imageCroqui && this.formData.imageCroqui.length;

      if (temCroquiDefinido) return;

      const image = new Image();
      image.crossOrigin = 'Anonymous';
      image.src = this.baseImageURL;
      image.onload = () => {
        this.baseImage = {
          x: 0,
          y: 0,
          image: image,
          width: this.stageSize.width,
          height: this.stageSize.height,
        };
      };
    },
    addElementCroqui(item) {
      const newIndex = this.croquiElements.length;
      const elementName = item.nome.split(' ').join('');

      const isTextElement = item.tipo === 'text';
      if (isTextElement) {
        const textObject = {
          x: 50,
          y: 50 + 30 * newIndex,
          text: 'Digite seu texto aqui',
          fontSize: 18,
          draggable: true,
          name: elementName + newIndex,
          width: 200,
          fontFamily: 'Arial',
          fill: '#000',
          align: 'center',
          id: 'text' + newIndex,
        };
        this.croquiElements.push(textObject);
        return;
      }

      const src = ['cars', 'motorcycles', 'trucks'].includes(item.tipo)
        ? CROQUI_ICONS[item.tipo][this.escolheIconeVeiculo(item.tipo)]
        : item.src;

      const object = {
        rotation: 0,
        x: 10 * (newIndex + 1),
        y: 10 * (newIndex + 1),
        scaleX: 1,
        scaleY: 1,
        name: elementName + newIndex,
        draggable: true,
        image: null,
      };

      const image = new Image();
      image.crossOrigin = 'Anonymous';
      image.src = src;
      image.width = 40;
      image.height = 40;
      image.onload = () => {
        object.image = image;
        this.croquiElements.push(object);
      };
    },
    printCroqui() {
      const data = this.$refs.stage.getStage().toDataURL();
      const blob = canvasToBlob(data);
      const formDataSend = new FormData();
      formDataSend.append('files', blob, 'croqui.png');
      return formDataSend;
    },
    async uploadCroquiAWS(formDataSend) {
      try {
        this.$vs.loading();

        const { uploadedFiles } = await service.uploadAll(
          'upload-multi',
          'Eventos/' + this.idEvento,
          formDataSend,
        );

        return uploadedFiles;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async salvarCroqui() {
      const formDataSend = this.printCroqui();
      const uploadedFiles = await this.uploadCroquiAWS(formDataSend);

      try {
        const croqui = {
          inserir: [
            {
              idEvento: this.idEvento,
              nome: uploadedFiles[0],
              legenda: 'croqui do evento',
              idFotoReferente: this.idReferente,
              uploadBy: this.idUsuario,
            },
          ],
          inativar: {
            idEvento: this.idEvento,
            idFotoReferente: this.idReferente,
          },
        };

        const result = await service.post(
          'eventos2',
          'registrar-imagem-croqui',
          croqui,
        );

        this.updateBaseImage(result.data);

        notify.notifySuccess(this.$vs, 'Imagem do croqui salva com sucesso!');

        return Promise.resolve();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    updateBaseImage(data) {
      this.imagemCroquiSava = data;

      const image = new Image();
      image.crossOrigin = 'Anonymous';
      image.src = data.nome;
      image.onload = () => {
        this.baseImage = {
          x: 0,
          y: 0,
          image: image,
          width: this.stageSize.width,
          height: this.stageSize.height,
        };
      };
    },
    resetCroqui() {
      this.croquiElements = [];
      this.loadBaseImage();
    },
    escolheIconeVeiculo(tipo) {
      const index = this.contador[tipo];
      if (index === 3) {
        this.contador[tipo] = 0;
      } else {
        this.contador[tipo]++;
      }
      return index;
    },
    handleTextDoubleClick(item) {
      const textNode = item.target;
      const textIndex = this.croquiElements.findIndex(
        ({ id }) => id === textNode.attrs.id,
      );

      const { text, fill } = this.croquiElements[textIndex];
      this.modalTextCroqui = true;
      this.croqui = {
        text,
        fill,
        id: textIndex,
      };
    },
    aplicaEstiloTextoCroqui() {
      const { text, fill, id } = this.croqui;
      const isValidEdit = text && fill && id >= 0;

      if (isValidEdit) {
        this.$set(this.croquiElements, id, {
          ...this.croquiElements[id],
          text,
          fill,
        });
      }
      this.modalTextCroqui = false;
    },
    preencheItemsCroqui() {
      this.tiposElementos = [
        { tipo: 'cars', nome: 'Adicionar Veículo', src: CROQUI_ICONS.cars[0] },
        {
          tipo: 'motorcycles',
          nome: 'Adicionar Motocicleta',
          src: CROQUI_ICONS.motorcycles[0],
        },
        {
          tipo: 'trucks',
          nome: 'Adicionar Caminhão',
          src: CROQUI_ICONS.trucks[0],
        },
        {
          tipo: 'pedestrians',
          nome: 'Adicionar Pedestre',
          src: CROQUI_ICONS.pedestrians[0],
        },
        ...CROQUI_ICONS.animals.map((src) => ({
          tipo: 'animals',
          nome: 'Adicionar Animal',
          src,
        })),
        ...CROQUI_ICONS.obstacles.map((src) => ({
          tipo: 'obstacles',
          nome: 'Adicionar Obstáculo',
          src,
        })),
        ...CROQUI_ICONS.plates.map((src) => ({
          tipo: 'plates',
          nome: 'Adicionar Sinalização',
          src,
        })),
        ...CROQUI_ICONS.arrows.map((src) => ({
          tipo: 'arrows',
          nome: 'Adicionar Seta',
          src,
        })),
        {
          tipo: 'text',
          nome: 'Adicionar Texto',
          src: CROQUI_ICONS.text[0],
        },
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
.baseContainer {
  width: 100%;
  padding-top: 80%; /* Define a altura em relação à largura */
  position: relative;
  overflow: hidden;

  .konvaContainer {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
}
.item-croqui {
  background: #d2f1ff;
}
.item-croqui:hover {
  background: #b7d8f8;
  transition: background 0.2s ease-in-out;
  cursor: pointer;
  span {
    transition: color 0.2s ease-in-out;
    color: white !important;
  }
}
</style>
<style>
.color-picker {
  border: none;
  border-radius: 50%;
  padding: 0;
  overflow: hidden;
  appearance: none;
  -webkit-appearance: none;
}

.color-picker::-webkit-color-swatch-wrapper {
  padding: 0;
  border-radius: 50%;
}

.color-picker::-webkit-color-swatch {
  border: none;
  border-radius: 50%;
}
</style>
